import React from "react";

import cx from "classnames";

import styles from "./Tooltip.scss";

/**
 * Props for the TooltipContent component.
 */
export interface TooltipContentProps {
  /**
   * Whether the tooltip hangs left
   */
  hangLeft?: boolean;
  /**
   * Class name of the tooltip panel
   */
  tooltipClassName?: string;
  /**
   * Content to display in the tooltip
   */
  content: React.ReactNode;
  /**
   * ID of the tooltip element
   */
  id: string;
}

/**
 * Content component for the Tooltip that displays the actual tooltip content.
 */
export function TooltipContent({
  hangLeft,
  tooltipClassName,
  content,
  id,
}: TooltipContentProps) {
  return (
    <div
      id={id}
      className={cx(
        styles["tooltip-content-active-state"],
        hangLeft && styles["tooltip-content-hang-left"],
        tooltipClassName
      )}
      data-testid="tooltip-content"
      role="tooltip"
    >
      {content}
    </div>
  );
}
